import constructResource from '../../utils/construct-resource';
import { internalModelFactoryFor } from './internal-model-factory';

/**
  @module @ember-data/store
*/

function metaIsRelationshipDefinition(meta) {
  return typeof meta._inverseKey === 'function';
}
let peekGraph;
if (true /* HAS_RECORD_DATA_PACKAGE */) {
  let _peekGraph;
  peekGraph = wrapper => {
    _peekGraph = _peekGraph || require('@ember-data/record-data/-private').peekGraph;
    return _peekGraph(wrapper);
  };
}
export default class RecordDataStoreWrapper {
  constructor(_store) {
    this._store = _store;
    this._willNotify = false;
    this._pendingNotifies = new Map();
  }
  get identifierCache() {
    return this._store.identifierCache;
  }
  _scheduleNotification(identifier, key, kind) {
    let pending = this._pendingNotifies.get(identifier);
    if (!pending) {
      pending = new Map();
      this._pendingNotifies.set(identifier, pending);
    }
    pending.set(key, kind);
    if (this._willNotify === true) {
      return;
    }
    this._willNotify = true;
    let backburner = this._store._backburner;
    backburner.schedule('notify', this, this._flushNotifications);
  }
  notifyErrorsChange(type, id, lid) {
    const resource = constructResource(type, id, lid);
    const identifier = this.identifierCache.getOrCreateRecordIdentifier(resource);
    let internalModel = internalModelFactoryFor(this._store).peek(identifier);
    if (internalModel) {
      internalModel.notifyErrorsChange();
    }
  }
  _flushNotifications() {
    if (this._willNotify === false) {
      return;
    }
    let pending = this._pendingNotifies;
    this._pendingNotifies = new Map();
    this._willNotify = false;
    const factory = internalModelFactoryFor(this._store);
    pending.forEach((map, identifier) => {
      const internalModel = factory.peek(identifier);
      if (internalModel) {
        map.forEach((kind, key) => {
          if (kind === 'belongsTo') {
            internalModel.notifyBelongsToChange(key);
          } else {
            internalModel.notifyHasManyChange(key);
          }
        });
      }
    });
  }
  attributesDefinitionFor(type) {
    return this._store._attributesDefinitionFor({
      type
    });
  }
  relationshipsDefinitionFor(type) {
    return this._store._relationshipsDefinitionFor({
      type
    });
  }
  inverseForRelationship(type, key) {
    const modelClass = this._store.modelFor(type);
    const definition = this.relationshipsDefinitionFor(type)[key];
    if (!definition) {
      return null;
    }
    if (metaIsRelationshipDefinition(definition)) {
      return definition._inverseKey(this._store, modelClass);
    } else if (definition.options && definition.options.inverse !== undefined) {
      return definition.options.inverse;
    } else {
      return null;
    }
  }
  inverseIsAsyncForRelationship(type, key) {
    const modelClass = this._store.modelFor(type);
    const definition = this.relationshipsDefinitionFor(type)[key];
    if (!definition) {
      return false;
    }
    if (definition.options && definition.options.inverse === null) {
      return false;
    }
    if (definition.inverseIsAsync !== undefined) {
      // TODO do we need to amend the RFC for this prop?
      // else we should add it to the TS interface and document.
      return !!definition.inverseIsAsync;
    } else if (metaIsRelationshipDefinition(definition)) {
      return definition._inverseIsAsync(this._store, modelClass);
    } else {
      return false;
    }
  }
  notifyPropertyChange(type, id, lid, key) {
    const resource = constructResource(type, id, lid);
    const identifier = this.identifierCache.getOrCreateRecordIdentifier(resource);
    let internalModel = internalModelFactoryFor(this._store).peek(identifier);
    if (internalModel) {
      internalModel.notifyPropertyChange(key);
    }
  }
  notifyHasManyChange(type, id, lid, key) {
    const resource = constructResource(type, id, lid);
    const identifier = this.identifierCache.getOrCreateRecordIdentifier(resource);
    this._scheduleNotification(identifier, key, 'hasMany');
  }
  notifyBelongsToChange(type, id, lid, key) {
    const resource = constructResource(type, id, lid);
    const identifier = this.identifierCache.getOrCreateRecordIdentifier(resource);
    this._scheduleNotification(identifier, key, 'belongsTo');
  }
  notifyStateChange(type, id, lid, key) {
    const resource = constructResource(type, id, lid);
    const identifier = this.identifierCache.getOrCreateRecordIdentifier(resource);
    let internalModel = internalModelFactoryFor(this._store).peek(identifier);
    if (internalModel) {
      internalModel.notifyStateChange(key);
    }
  }
  recordDataFor(type, id, lid) {
    let identifier;
    let isCreate = false;
    if (!id && !lid) {
      isCreate = true;
      identifier = {
        type
      };
    } else {
      const resource = constructResource(type, id, lid);
      identifier = this.identifierCache.getOrCreateRecordIdentifier(resource);
    }
    return this._store.recordDataFor(identifier, isCreate);
  }
  setRecordId(type, id, lid) {
    this._store.setRecordId(type, id, lid);
  }
  isRecordInUse(type, id, lid) {
    const resource = constructResource(type, id, lid);
    const identifier = this.identifierCache.getOrCreateRecordIdentifier(resource);
    const internalModel = internalModelFactoryFor(this._store).peek(identifier);
    if (!internalModel) {
      return false;
    }
    const record = internalModel._record;
    return record && !(record.isDestroyed || record.isDestroying);
  }
  disconnectRecord(type, id, lid) {
    const resource = constructResource(type, id, lid);
    const identifier = this.identifierCache.getOrCreateRecordIdentifier(resource);
    if (true /* HAS_RECORD_DATA_PACKAGE */) {
      let graph = peekGraph(this);
      if (graph) {
        graph.remove(identifier);
      }
    }
    let internalModel = internalModelFactoryFor(this._store).peek(identifier);
    if (internalModel) {
      internalModel.destroyFromRecordData();
    }
  }
}